import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { NavigationService } from './navigation.service';
import { AuthGuard } from './auth.guard';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../api.service';

@Injectable()
export class AuthRequiredGuard  {
  constructor(
    private authService: AuthService,
    private navigationService: NavigationService,
    private apiService: ApiService,
    private authGuard: AuthGuard
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const urlProcessResult = this.apiService.processUrlWithToken(state.url);
    state.url = urlProcessResult.url;

    return this.authGuard.canActivate(next, state).pipe(
      map(() => {
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        return this.authService.isFullyAuthenticated() || !this.navigationService.handleLogin(false, { returnTo: state.url });
      })
    );
  }
}
